<template>
	<div>
		<el-card>
			<div slot="header">
				<span class="top_title">收款记录</span>
			</div>
			<div class="searchItem">
				<div class="search">
					<span class="searchtips">日期:</span>
					<el-date-picker
						v-model="search.daterange"
						type="datetimerange"
						:picker-options="pickerOptions"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						style="width: 230px"
						format="yyyy-MM-dd HH:mm"
						value-format="yyyy-MM-dd HH:mm"
					>
					</el-date-picker>
				</div>
				<div style="padding-right:10px">
					<Customer :orderForm="search" :hideStar='true'></Customer>
				</div>
				<div class="search">
					<span class="searchtips">来源:</span>
					<el-select style="width:180px" v-model="search.from" multiple collapse-tags placeholder="">
						<el-option key="order" label="订单收款" value="订单收款"></el-option>
						<el-option key="cust" label="客户收款" value="客户收款"></el-option>
					</el-select>
				</div>
				<div class="search">
					<el-button type="primary" @click="searchData" icon="el-icon-search">查询</el-button>
				</div>
				<div class="search">
					<el-button
						type="primary"
						icon="el-icon-printer"
						@click="print"
						v-if="$common.checkWindowsEnv()"
						>打印</el-button>
					<el-button
						type='primary'
						icon="el-icon-document"
						@click="changePdf"
					>导出</el-button>
				</div>
			</div>
			<div style="position: relative">
				<div style="display:flex;justify-content: space-between;margin-bottom:20px">
					<el-button @click="colsDialog = !colsDialog">
						列设置
					</el-button>
					<div style="display:flex;">
						<el-button type="primary" @click="addDialog = !addDialog" v-if="$common.hasLimits('addcpayAdd')">
							新增收款
						</el-button>
						<el-button type="primary" @click="addPDialog = !addPDialog" v-if="$common.hasLimits('addPayment')">
							新增收支
						</el-button>
					</div>
				</div>
			</div>
			<el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" :summary-method="getSummaries" show-summary style="width: 100%;margin-bottom: 20px;" border>
				<template>
					<el-table-column width='80px' label="操作" align='center' v-if="$common.hasLimits('paymentCancel')">
						<template slot-scope="{row}">
							<el-button type="text" @click="delone(row.uuid)">取消</el-button>
						</template>
					</el-table-column>
				</template>
				<template v-for="(col, index) in cols">
					<el-table-column v-if="col.show" :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align" show-overflow-tooltip>
						<template #header v-if="col.column">
							{{col.label}}
							<el-button circle icon="el-icon-top" size="mini" v-if="search.column==col.column&&search.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
							<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
							<el-button circle icon="el-icon-bottom" size="mini" v-if="search.column==col.column&&search.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
							<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
						</template>
						<template slot-scope="{row}">
							<template v-if="col.type=='remark'">
								<div class="uni_ellipsis">{{ row.remark }}</div>
							</template>
							<template v-else-if="col.type=='pfrom'">
								<div>{{ row.pfrom=='订单收款'?row.pfrom+row.onumber:row.pfrom}}</div>
							</template>
							<template v-else>
								{{ row[col.prop] }}
							</template>
						</template>
					</el-table-column>
				</template>
			</el-table>

			<el-pagination  style="text-align: right;" :page-sizes="page.limits" :page-size="page.limit" layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5" />
			<el-dialog :visible.sync="addDialog" title="新增收款" width="90%">
				<add-cpay :dialog="1" @save="saveCpay" @cancel="cancelCpay" />
			</el-dialog>
			<el-dialog :visible.sync="addPDialog" title="新增收支" width="90%">
				<add-pay v-if="addPDialog" :dialog="1" @save="savePpay" @cancel="cancelPpay" />
			</el-dialog>
			<el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
				<column-edit :cols="cols" />
				<div slot="footer" class="dialog-footer">
					<el-button type="text" @click="cols = initCols();" style="float:left">恢复默认设置</el-button>
					<el-button type="primary" @click="saveCols()">保存</el-button>
				</div>
			</el-dialog>
		</el-card>
		<ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
	</div>
</template>

<script>
	import AddCpay from './addcpay.vue';
	import AddPay from './addpay.vue';
	import Customer from '@/components/customer.vue'
	import ColumnEdit from '@/components/table-column/Column.vue';
	import ReportOrder from '@/components/printshare/reportorder.vue';
	import editShare from '@/components/printshare/edit_share';
	export default {
		components: {
			AddCpay,
			AddPay,
			ColumnEdit,
			Customer,
			editShare,
			ReportOrder,
		},
		data() {
			return {
				loading: true,
				cloading: false,
				colsDialog:false,
				addDialog: false,
				addPDialog: false,
				tableData: [],
				sumData: {},
				host: this.$api.baseURL,
				cols: [],
				pickerOptions: {shortcuts:this.$common.initPickerOptions()},
				search: {
					cid: '',
					from: [],
					daterange:[],
					column:'',
					order:'',
				},
				oid: 2,
				page: {
					current: 1,
					total: 0,
					limit: 20,
					limits: [20, 50, 120, 250],
				},
				searchObj:{
					page:1,
					limit:20,
				},
			}
		},
		mounted() {
			this.getData();
			this.$api.getTableCols({tableName: 'ipad_payment'}).then(res=>{
				if(res.data.code==1){
					let obj = res.data.data;
					if(obj.cols){
						let arr = this.initCols();
                        obj.cols.forEach(e=>{
                            let prop = e.prop;
                            let show = e.show;
                            for(let i in arr){
                                if(arr[i].prop==prop){
                                    let target = arr.splice(i,1);
                                    target[0].show = show;
                                    this.cols.push(target[0]);
                                    break;
                                }
                            }
                        })
                        if(arr.length>0){
                            this.cols.push(...arr);
                        }
					}else{
                        this.cols = this.initCols();
                    }
				}else{
                    this.cols = this.initCols();
                }
			})
		},
		methods: {
			print(){
				let array = [];
				let cmp = this.$global.cmpId.cmp;
				array.push(cmp);
				this.$nextTick(()=>{
					this.$refs.roder.extraOpen(7,array);
				})
			},
			changePdf(){
				let array = [1];
				this.$nextTick(()=>{
					this.$refs.share.openList(array,7,this.searchObj);
				})
			},
			initCols(){
				let arr = [
					{
						prop: 'date',
						label: '日期',
						edit: '',
						type: '',
						width: 160,
						show: true,
						column:'date',
					},
					{
						prop: 'cname',
						label: '客户',
						edit: '',
						type: '',
						width: 200,
						show: true
					},
					{
						prop: 'pay',
						label: '收款(元)',
						edit: '',
						type: '',
						width: 150,
						show: true,
						column:'pay',
					},{
						prop: 'backed',
						label: '退款(元)',
						edit: '',
						type: '',
						width: 150,
						show: true,
						column:'backed',
					}, {
						prop: 'free',
						label: '免除(元)',
						edit: '',
						type: '',
						width: 150,
						show: true,
						column:'free'
					},{
						prop: 'otherBack',
						label: '零星退货(元)',
						edit: '',
						type: '',
						width: 175,
						show: true,
						column:'otherBack'
					},
					{
						prop: 'pfrom',
						label: '来源',
						edit: '',
						type: 'pfrom',
						width: 200,
						show: true
					},
					{
						prop: 'accountname',
						label: '结算账号',
						edit: '',
						type: '',
						width: 160,
						show: true
					},
					{
						prop: 'cteator',
						label: '经办人',
						edit: '',
						type: '',
						width: 180,
						show: true
					}, 
					{
						prop: 'remark',
						label: '备注',
						edit: '',
						type: 'remark',
						width: 200,
						show: true
					}
				]
				return arr;
			},
			saveCols(){
				let obj = {
					tableName:'ipad_payment',
					data:JSON.stringify(this.cols),
				}
				this.$api.setTableCols(obj).then(res=>{
					if(res.data.code==1){
						this.$notify({
							title: "列设置",
							message: "修改成功",
							type: "success",
							duration: 2000,
						});
					}
				})
            	this.colsDialog = false;
        	},
			searchData() {
				this.page.current=1;
				this.searchObj = {
					page:this.page.current,
					limit:this.page.limit,
					cid:this.search.cid,
					from:this.search.from.join(","),
					start: this.search.daterange==null||this.search.daterange.length==0 ? "" : this.search.daterange[0],
					end: this.search.daterange==null||this.search.daterange.length==0 ? "" : this.search.daterange[1],
				}
				this.sortTime();
			},
			setSort(column,order){
            if(this.search.column==column&&this.search.order==order){
                this.search.column = '';
                this.search.order = '';
            }else{
                this.search.column = column;
                this.search.order = order;
            }
            this.sortTime();
        },
			sortTime(){
				if(this.search.column){
					this.searchObj.column = this.search.column;
					this.searchObj.order = this.search.order?'asc':'desc';
				}else{
					delete this.searchObj.column;
					delete this.searchObj.order;
				}
				this.getData();
			},
			getData() {
				this.loading = true;
				this.$api.listPayment(this.searchObj).then(res => {
					this.loading = false
					if(res.data.code==1){
						let dd = res.data.data;
						this.tableData = dd.data
						this.page.total = dd.count
						this.sumData = {
							sumPay: dd.sumPay,
							sumFree: dd.sumFree,
							sumBack: dd.sumBack,
							sumBill: dd.sumBill,
							sumOtherBack: dd.sumOtherBack,
						}
					}
				}, res => {
					this.loading = false
				})
			},
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if(index === 1) {
						sums[index] = '全部总计';
						return;
					}
					var sumitem = {
						pay: 'sumPay',
						backed: 'sumBack',
						free: 'sumFree',
						bill: 'sumBill',
						otherBack:'sumOtherBack',
					}
					var sum = this.sumData[sumitem[column.property]]
					sums[index] = sum == undefined || sum == null ? "" : sum
				});
				return sums
			},

			handleSizeChange(val) {
				this.page.limit = val;
				this.searchData();
			},
			handleCurrentChange(val) {
				this.page.current = val;
				this.searchObj.page = val;
				this.getData();
			},
			saveCpay(res) {
				this.addDialog = false;
				this.getData();
			},
			cancelCpay() {
				this.addDialog = false
			},
			savePpay() {
				this.addPDialog = false;
				this.getData();
			},
			cancelPpay() {
				this.addPDialog = false
			},
			delone(id){
				this.$api.cancelCustomerPayment({uuids:id}).then(res=>{
					if(res.data.code==1){
						this.$notify({
							title: "收款记录",
							message: "删除成功",
							type: "success",
							duration: 1000,
						});
						this.getData();
					}
				})
			},
		}
	}
</script>